import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import FormSection from "../formSectionNew";
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { handleValidateObj } from "constants/objValues/objvalues";
import Regex from "services/utils/regex/Regex";
import DatePicker from "components/sales/datePicker/datePicker";
import { handleFormatDate } from "constants/dateFormat/dateFormat";
import FileUpload from "components/sales/fileUpload/fileUpload";
import "./corpNew.css";
import moment from "moment";
import ModalPop from "components/sales/modal/modal";
import { toast } from "react-toastify";

const CommercialNew = ({
  data,
  handleValue,
  isApartment = false,
  isSupply = false,
  supplyNameFun = null,
  splNameData,
  edit = 0,
  documentUploadUrl,
  prefilledData,
  is_fastag,
  isRenewal = false,
  handleCommercialSubmit,
  userRoleBasedDropdown,
  getUserBasedDropdown,
  saveExternalUserData,
  insertExternalUser,
  setIsLoading,
  leadId,
  isEcom
}) => {
  const {
    commercialTypes,
    paymentMode,
    solution_type,
    paymentTerms,
    products,
    no_of_slots,
    lead_category,
    paymentDueDays,
    channelPartnerData,
    cp_permission = 0,
    leadType,
  } = data;
  const commercialInput = {
    formStage:2,
    commercialType: '',
    clientShare: '',
    companyShare: '',
    costPerSlot: '',
    totalAmount: 0,
    MGSlots: '',
    revenueSlots: '',
    MGPerSlot: '',
    revenueShare: '',
    supplyName: '',
    takeEtaxes: '',
    takePerct: '',
    paymentTermsDesc: '',
    paymentTerms: '',
    latePayCharge:'0',
    products: '',
    paymentTerms2: '',
    paymentMode: '',
    solution_type:'',
    solution_type_name:'',
    totalContract: '',
    LockIn: '',
    yearlyInclin: '',
    securityDeposit: '',
    slotsNoFourWheeler: '',
    slotsNoTwoWheeler: '',
    TagsNoPost: '',
    installationAmount: '',
    subAmt: '',
    parkCommission: '',
    slots4MgCar: '',
    slots2MgBike: '',
    slotsRevenue4Car: '',
    slotsRevenue2Bike: '',
    otherDetailsTerms: '',
    valetProduct: '',
    advertisingCommercials: '',
    paymentDueDays: '',
    expectedLive: '',
    commercialPrefilled: { id: null, value: '' },
    payModePrefilled: { id: null, value: '' },
    payDueDaysPrefilled: { id: null, value: '' },
    solutionPrefilled: { id: null, value: '' },
    productPrefilled: { id: null, value: '' },
    paymentTermPrefilled: { id: null, value: '' },
    latePaymentPrefilled: { id: null, value: '' },
    rel_docs: '',
    commission: '',
    agreementContractPeriodTo:'',
    agreementContractPeriodFrom:'',
    agreementSigningDate:'',
    contract_doc:'',
    salesType: '',
    channelPartner: '',
    channelPartnerValue: '',
    channelPartnerWarehouse: '',
    invoice_type: '',
    managementFee: 0,
    // fastag_integrable:'',
    isPOAvailable:'',
    detailsProvide:'',
    detailsProvideName:'',
    pONumber: '',
    pODate: '',
    optFor:'',
    opt_amount:'',
    invoice_gen:'',
    pOUpload:'',
    contractTypePrefilled: { id: null, value: '' },
    leadType:leadType,
    builderType:'',
  };

  const services = "Valet";
  const monthly = "Monthly";
  const valeyService = "Valet Services";
  const [serviceCheck, setServiceCheck] = useState(false);
  const [supplyCost, setSupplyCost] = useState("");
  const [commercialData, setCommercialData] = useState(commercialInput);
  const [isTarget, setIsTarget] = useState("");
  const [totalContractList, setTotalContractList] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [solutionTypeS, setSolutionTypeS] = useState();
  const [minDateIndex, setMinDateIndex] = useState(null);
  const [solutionTypePre, setsolutionTypePre] = useState({ id: "", value: "" });
  const [agreementEndDate, setAgreementEndDate] = useState(null);
  const [agreementSignDate, setAgreementSignDate] = useState(null);
  const [agreementLength, setAgreementLength] = useState(null);
  const [saleType, setSaleType] = useState("");
  const [saleTypeName, setSaleTypeName] = useState("");
  const [paymentTermsData, setPaymentTermsData] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [contractCommericalTypes, setContractCommericalTypes] = useState([]);

  const timersRef = useRef([]);
  const setSafeTimeout = (fn, ms) => {
    const id = setTimeout(fn, ms);
    timersRef.current.push(id);
    return id;
  };

  useEffect(() => {
    return () => {
      timersRef.current.forEach((t) => clearTimeout(t));
      timersRef.current = [];
    };
  }, []);

  useEffect(() => {
    if (isEcom) {
      setContractCommericalTypes([
        { id: 7, name: "Rental" }
      ]);
    } else {
      setContractCommericalTypes([
        { id: 5, name: "Capex" },
        { id: 6, name: "Opex" },
        { id: 7, name: "Rental" }
      ]);
    }
  }, []);

  let solutionTypeId = 0;
  let paymentTermsId = 0;
  let productsId = 0;
  //   console.log('types ', commercialTypes);
  useEffect(() => {
    setPaymentTermsData(paymentTerms);
    setIsTarget(7);
    setCommercialData({
      ...commercialInput,
      commercialType: 7,
      solution_type: solutionTypeS,
      solutionPrefilled: solutionTypePre,
      commercialPrefilled: {id: 7, value: 'Rental'}
    });
    setSafeTimeout(() => {
      setDisabled(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (data) {
      setSupplyCost(data && data.supply_cost_per_slot);
    }
  }, [data]);

  const handleIdvalueType = (evt) => {
    setIsTarget(parseInt(evt?.id));
    setSafeTimeout(() => {
      setCommercialData({
        // ...commercialData,
        ...commercialInput,
        commercialType: parseInt(evt?.id),
        solution_type: commercialData?.solution_type,
        solutionPrefilled: commercialData?.solutionPrefilled,
        commercialPrefilled: evt
      });
    }, 100);
  };

  useEffect(() => {
    if (
      prefilledData?.commercial !== undefined &&
      prefilledData?.commercial !== null
    ) {
      const {
        commercialName,
        commercial_type_id,
        commercial_description,
        total_mg_amount,
        payment_term,
        payment_term_type,
        payment_mode,
        payment_mode_id,
        solution_type_name,
        solution_type,
        installation_amount,
        subscription_amount,
        contract_length,
        contract_lockin_period,
        product_id,
        late_payment_charge,
        payment_term_desciption,
        payment_due_days,
        payment_due_days_name,
        expected_live_date,
        mdr_percentage,
        contract_document,
        contract_to_date,
        contract_from_date,
        contract_sign_date,
        type_of_sales,
        channel_partner,
        other_cp_name,
        po_number,
        po_date,
        po_document,
        builderType,
        external_user_id,
        external_user_name,
        invoice_type
        // fastag_integrable
      } = prefilledData?.commercial;

      const { security_deposit, product_details } = prefilledData;

      setIsTarget(commercial_type_id);
      setSafeTimeout(() => {
        setCommercialData({
          // ...commercialData,
          formStage: commercialInput?.formStage,
          commercialType: commercial_type_id,
          commercialPrefilled: {
            id: commercial_type_id,
            value: commercialName,
          },
          paymentTermsDesc: commercial_description,
          totalAmount: total_mg_amount,
          paymentMode: payment_mode_id,
          solution_type: solution_type,
          solutionPrefilled: { id: solution_type, value: solution_type_name },
          payModePrefilled: { id: payment_mode_id, value: payment_mode },

          payDueDaysPrefilled: {
            id: payment_due_days,
            value: payment_due_days_name,
          },
          totalContract: contract_length.toString(),
          LockIn: contract_lockin_period,
          securityDeposit: security_deposit != null ? security_deposit : "0",
          expectedLive: expected_live_date,
          productPrefilled: {
            id: product_details?.id,
            value: product_details?.name,
          },
          paymentTermPrefilled: { id: payment_term_type, value: payment_term },

          latePaymentPrefilled: {
            id: late_payment_charge.toString(),
            value: late_payment_charge + "%",
          },
          subAmt: subscription_amount,
          paymentDueDays: payment_due_days,
          products: product_details.id,
          paymentTerms: payment_term_type,
          latePayCharge: late_payment_charge,
          commission: mdr_percentage,
          contract_doc: contract_document,
          agreementEndDate: contract_to_date,
          agreementContractPeriodTo: contract_to_date,
          agreementSigningDate: contract_sign_date,
          agreementContractPeriodFrom: contract_from_date,
          salesType: type_of_sales,
          channelPartner: channel_partner ?? "",
          channelPartnerValue: other_cp_name ?? "",
          isPOAvailable: po_number && po_number != "" ? "Yes" : "No",
          pONumber: po_number,
          pODate: moment(po_date, "YYYY-MM-DD").format("DD-MM-YYYY"),
          pOUpload: po_document,
          builderType: builderType,
          leadType: leadType,
          invoice_type: invoice_type,
          // fastag_integrable: fastag_integrable,
          externalUserPrefilled: {
            id: external_user_id,
            value: external_user_name,
          }
        });
        // contract_length
        setAgreementLength(contract_length.toString());
        setSaleType(type_of_sales);
        setSaleTypeName(type_of_sales);
        setSolutionTypeS(solution_type);
        setsolutionTypePre({ id: solution_type, value: solution_type_name });
      }, 200);
    }
  }, [prefilledData, paymentTerms]);

  useEffect(() => {
    if (saleType == "Direct Sales") {
      setCommercialData({
        ...commercialData,
        channelPartner: "",
        channelPartnerValue: "",
      });
    }
  }, [saleType]);

  // useEffect(() => {
  //   if (supplyNameFun !== null) (async () => await supplyNameFun())();
  // }, [supplyNameFun]);

  useEffect(() => {
    let count = 60;
    for (let i = 1; i <= count; i++) {
      if (i === 1) {
        totalContractList.push({
          name: `${i} month`,
          id: `${i} month`,
        });
      } else {
        totalContractList.push({
          name: i === 60 ? `${i}+ months` : `${i} months`,
          id: `${i} months`,
        });
      }
    }
    setTotalContractList(totalContractList);
  }, [totalContractList]);
  useEffect(() => {
    if (isTarget === 5) {
      setCommercialData({ ...commercialData, TagsNoPost: "2235" });
    }
  }, [isTarget]);

  useEffect(() => {
    if (isTarget === 3) {
      setCommercialData({
        ...commercialData,
        revenueSlots: `${
          Number(commercialData.totalAmount) - Number(commercialData.MGSlots)
        }`,
        MGPerSlot: `${Number(
          Number(commercialData.totalAmount) / Number(commercialData.MGSlots)
        ).toFixed()}`,
      });
    }
  }, [commercialData.MGSlots, isTarget]);

  useEffect(() => {
    if (isTarget === 2) {
      setCommercialData({
        ...commercialData,
        costPerSlot: `${(
          Number(commercialData.totalAmount) / no_of_slots
        ).toFixed(2)}`,
      });
    }
  }, [commercialData.totalAmount, isTarget]);

  useEffect(() => {
    if (isTarget === 4) {
      setCommercialData({
        ...commercialData,
        // takeEtaxes: `${
        //   Number(commercialData.costPerSlot) - Number(supplyCost)
        // }`,
        takePerct: `${Math.round(
          (Number(commercialData.takeEtaxes) /
            (Number(commercialData.costPerSlot) - Number(supplyCost))) *
            100
        )}`,
      });
    }
  }, [commercialData.takeEtaxes, isTarget]);

  const handleClientShare = (val) => {
    const clientNumber = Number(val);
    if (clientNumber > 100 || clientNumber < 0) {
      return false;
    } else {
      setCommercialData({
        ...commercialData,
        clientShare: val,
        companyShare: clientNumber > 0 ? `${100 - clientNumber}` : "",
      });
    }
  };

  const handleCommercialDataNew = () => {
    handleValue(commercialData);
  };

  const handleCommercialData = () => {
    if (isSupply === true) {
      const supplyObj = {
        totalContract: commercialData.totalContract,
        LockIn: commercialData.LockIn,
        paymentDueDays: commercialData.paymentDueDays,
      };
      if (isTarget === 5 || isTarget === 7 || isTarget === 16) {
        if (lead_category?.id) {
          if (
            lead_category?.id === 9 ||
            lead_category?.id === 10 ||
            lead_category?.id === 11
          ) {
            supplyObj.installationAmount = commercialData.installationAmount;
            supplyObj.subAmt = commercialData.subAmt;
            supplyObj.paymentMode = commercialData.paymentMode;
            if (lead_category?.id === 10) {
              supplyObj.valetProduct = commercialData.valetProduct;
            }
            if (lead_category?.id === 11) {
              supplyObj.advertisingCommercials =
                commercialData.advertisingCommercials;
            }
          }
        }
      }
      if (isTarget === 15) {
        supplyObj.commission = commercialData.commission;
      }
      if (isRenewal == false) {
        supplyObj.products = commercialData.products;
        supplyObj.expectedLive = commercialData.expectedLive;
        if (commercialData?.solution_type) {
          supplyObj.solution_type = commercialData?.solution_type;
        } else {
          supplyObj.solution_type = "";
        }
      }
      const isNotEmpty = handleValidateObj(supplyObj);
      if (isNotEmpty !== false) {
        supplyObj.paymentTerms = commercialData.paymentTerms;
        handleValue(commercialData);
      } else {
        handleValue(null);
      }
    } else {
      if (isTarget === 1) {
        const revenueShare = {
          companyShare: commercialData.companyShare,
          costPerSlot: commercialData.costPerSlot,
          clientShare: commercialData.clientShare,
        };
        const isNotEmpty = handleValidateObj({ ...revenueShare });
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (isTarget === 2) {
        const mgObj = {
          totalAmount: commercialData.totalAmount,
          costPerSlot: commercialData.costPerSlot,
        };
        const isNotEmpty = handleValidateObj({ ...mgObj });
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (isTarget === 3) {
        const hybridObj = {
          totalAmount: commercialData.totalAmount,
          MGSlots: commercialData.MGSlots,
          revenueSlots: commercialData.revenueSlots,
          clientShare: commercialData.clientShare,
          companyShare: commercialData.companyShare,
          MGPerSlot: commercialData.MGPerSlot,
          revenueShare: commercialData.revenueShare,
        };
        const isNotEmpty = handleValidateObj(hybridObj);
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (isTarget === 4) {
        const payPerObj = {
          costPerSlot: commercialData.costPerSlot,
          takeEtaxes: commercialData.takeEtaxes,
          takePerct: commercialData.takePerct,
        };
        const isNotEmpty = handleValidateObj({ ...payPerObj });
        if (isNotEmpty !== false) {
          handleValue(commercialData);
        } else {
          handleValue(null);
        }
      }
      if (
        isTarget === 5 ||
        isTarget === 6 ||
        isTarget === 7 ||
        isTarget === 16
      ) {
        const capex = {
          totalContract: commercialData.totalContract,
          LockIn: commercialData.LockIn,
          paymentDueDays: commercialData.paymentDueDays,
        };
        if (isTarget === 5) {
          capex.totalAmount = commercialData.totalAmount;
        }
        if (isTarget === 6 || isTarget === 7 || isTarget === 16) {
          // capex.installationAmount = commercialData.installationAmount;
          capex.subAmt = commercialData.subAmt;
          // capex.yearlyInclin = commercialData.yearlyInclin;
        }
        if (lead_category?.id === 2) {
          capex.supplyName = commercialData?.supplyName;
        }
        if (commercialData?.paymentMode) {
          capex.paymentMode = commercialData?.paymentMode;
        }
        if (isRenewal == false) {
          if (commercialData?.solution_type) {
            capex.expectedLive = commercialData.expectedLive;
            capex.products = commercialData.products;
            capex.solution_type = commercialData?.solution_type;
          } else {
            capex.solution_type = "";
          }
        }

        const isNotEmpty = handleValidateObj(capex);
        if (isNotEmpty !== false) {
          handleValue({
            ...commercialData,
            paymentTermsDesc: commercialData.paymentTermsDesc,
          });
        } else {
          handleValue(null);
        }
      }
    }
  };

  const openAgreementBlock = (val) => {
    if (val != "Invalid Date") {
      var dateParts = val.split("-");
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      setMinDateIndex(dateObject);
      setAgreementDates(val);
    } else {
      setMinDateIndex(null);
    }
  };

  const setAgreementDates = (val) => {
    if (val != "Invalid date") {
      var dateParts = val.split("-");
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      var newDate = new Date(
        dateObject.setMonth(dateObject.getMonth() + parseInt(agreementLength))
      );
      setAgreementEndDate(newDate);
      let formatDate = "";
      if (newDate) {
        var dd = newDate.getDate();
        var mm = newDate.getMonth() + 1;
        var yyyy = newDate.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        formatDate = dd + "-" + mm + "-" + yyyy;
      }
      setCommercialData({
        ...commercialData,
        agreementSigningDate: val,
        agreementContractPeriodFrom: val,
        agreementContractPeriodTo: formatDate,
      });
      // console.log(agreementData);
    } else {
      setAgreementEndDate(null);
    }
  };

  const setAgreementEndLength = (val) => {
    if (val != "Invalid date") {
      var dateParts = val.split("-");
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      var newDate = new Date(
        dateObject.setMonth(dateObject.getMonth() + parseInt(agreementLength))
      );
      setAgreementEndDate(newDate);
      let formatDate = "";
      if (newDate) {
        var dd = newDate.getDate();
        var mm = newDate.getMonth() + 1;
        var yyyy = newDate.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        formatDate = dd + "-" + mm + "-" + yyyy;
      }
      setCommercialData({
        ...commercialData,
        agreementContractPeriodFrom: val,
        agreementContractPeriodTo: formatDate,
      });
    } else {
      setAgreementEndDate(null);
    }
  };

  useEffect(() => {
    // handleCommercialData();
    handleCommercialDataNew();
  }, [commercialData]);

  useEffect(() => {
    if (
      commercialData?.agreementContractPeriodFrom &&
      commercialData?.totalContract
    ) {
      setAgreementEndLength(commercialData?.agreementContractPeriodFrom);
    }
  }, [
    agreementLength,
    commercialData?.agreementContractPeriodFrom,
    commercialData?.agreementSigningDate,
  ]);

  const handleSalesType = (val) => {
    setSaleType(val.id);
    setSaleTypeName(val.id);
    setCommercialData({
      ...commercialData,
      salesType: val.id,
    });
  };

  // console.log('data ', commercialData);
  if (data?.solutionType) {
    data.solutionType.forEach((element) => {
      if (element.name == services) {
        solutionTypeId = element.id;
      }
    });
  }
  if (paymentTerms) {
    paymentTerms.forEach((element) => {
      if (element.name == monthly) {
        paymentTermsId = element.id;
      }
    });
  }
  if (products) {
    products.forEach((element) => {
      if (element.name == valeyService) {
        productsId = element.id;
      }
    });
  }

  // Unused: Select User UI that consumed getUserBasedDropdown is commented out.
  // useEffect(() => {
  //   if (leadType && leadId) {
  //     (async () => {
  //       setIsLoading(true);
  //       await userRoleBasedDropdown(leadType, leadId);
  //       setIsLoading(false);
  //     })();
  //   }
  // }, [userRoleBasedDropdown, leadType, leadId]);

  const handleCreateUserModal = () => {
    setCreateUserModal(true);
  };

  const handleModalHide = () => setCreateUserModal(false);

  const [inputData, setInputData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_id: "",
    external_role: ""
  });

  const handleInputValue = (key, val) => {
    setInputData({
      ...inputData,
      [key]: val, 
    });
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    if(inputData?.first_name == ''){
      toast.error('Please enter the first name')
      return false;
    }
    if(inputData?.last_name == ''){
      toast.error('Please enter the last name')
      return false;
    }
    if(inputData?.email == ''){
      toast.error('Please enter the email id')
      return false;
    }
    if(inputData?.external_role == ''){
      toast.error('Please select the role')
      return false;
    }
    const payload = {
      'name': `${inputData?.first_name || ''} ${inputData?.last_name || ''}`.trim(),
      'mobile_number': inputData?.mobile_number,
      'email': inputData?.email_id,
      'role': inputData?.external_role,
      'status': 1,
      'is_external': 1,
      'lead_type_id': leadType
    };
    setIsLoading(true);
    const res = await saveExternalUserData(payload);
    setCreateUserModal(false);
    setIsLoading(false);
  };
  

useEffect(() => {
  if (
    insertExternalUser?.data !== undefined &&
    insertExternalUser?.status === 200
  ) {
    // Unused: Select User UI that consumed getUserBasedDropdown is commented out.
    // if (leadType && leadId) {
    //   (async () => {
    //     setIsLoading(true);
    //     await userRoleBasedDropdown(leadType, leadId);
    //     setIsLoading(false);
    //   })();
    // }
    toast.success(insertExternalUser?.message)
  } else if (
    insertExternalUser?.data !== undefined &&
    insertExternalUser?.status !== 200
  ) {
    toast.error(insertExternalUser?.message)
  }
}, [insertExternalUser, leadType, leadId]);

// console.log("COMMERCIAL DETAILS: ", commercialData)

  return (
    <Fragment>
      {/* <div className='mk-line-b mt-4 mb-4'></div> */}
      <div className="card">
        <div className="card-header n-card">
          <div className="row">
            <div className="col-md-3">{localization.commercialType}</div>
            {/* <div className="col-md-3 d-flex">
              <input
                onChange={(e) => handleIdvalueType(e.target.value)}
                value={7}
                type="radio"
                id={`rental_contract`}
                checked={
                  parseInt(commercialData?.commercialType) === 7 ? true : false
                }
                name={`Rental`}
                className="mx-1"
                disabled={prefilledData?.commercial?.form_stage > 1}
              />
              <span className="com-span-x">Rental</span>
            </div>
            <div className="col-md-3 d-flex">
              <input
                onChange={(e) => handleIdvalueType(e.target.value)}
                value={5}
                type="radio"
                id={`capex_contract`}
                checked={
                  parseInt(commercialData?.commercialType) === 5 ? true : false
                }
                name={`Capex`}
                className="mx-1"
                disabled={prefilledData?.commercial?.form_stage > 1}
              />
              <span className="com-span-x">Capex</span>
            </div>
            <div className="col-md-3 d-flex">
              <input
                onChange={(e) => handleIdvalueType(e.target.value)}
                value={6}
                type="radio"
                id={`opex_contract`}
                checked={
                  parseInt(commercialData?.commercialType) === 6 ? true : false
                }
                name={`Opex`}
                className="mx-1"
                disabled={prefilledData?.commercial?.form_stage > 1}
              />
              <span className="com-span-x">Opex</span>
            </div> */}
          </div>
          {/* <DropDownInput
          data={commercialTypes}
          label={localization.commercialType}
          required
          isStarRequired={true}
          errorMsg={localization.requiredcommercialType}
          getIdValue={(val) => handleIdvalue(val)}
          value={commercialData.commercialPrefilled.value}
          disabled = {edit == 1 ?true:false}
        /> */}
        </div>

        {/* </FormSection> */}

        {/* is supply is available */}
        {/* {isSupply === true && (
        <Fragment>
          <FormSection title={localization.commercialDisc}>
            
            {lead_category?.id && (
              <Fragment>
                {lead_category?.id === 9 ||
                lead_category?.id === 10 ||
                lead_category?.id === 11 ? (
                  <Fragment>
                    <ConstantInput
                      label={localization.installationAmount}
                      errorMsg={
                        commercialData.installationAmount === ''
                          ? localization.requiredinstallationAmount
                          : localization.numericError
                      }
                      required
                      isStarRequired={true}
                      type="text"
                      regex={Regex.number.test(
                        commercialData.installationAmount
                      )}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          installationAmount: val,
                        })
                      }
                    />
                    
                  </Fragment>
                ) : null}
              </Fragment>
            )}
          </FormSection>
        </Fragment>
      )} */}
        {/* end of supply is available sec */}
        {isTarget ? (
          <Fragment>
            {isSupply !== true && (
              <Fragment>
                {isTarget === 1 ? (
                  <Fragment>
                    <FormSection title={localization.commercialDisc}>
                      <ConstantInput
                        label={localization.clientShare}
                        errorMsg={localization.requiredclientShare}
                        required
                        isStarRequired={true}
                        regex={Regex.toFixed.test(commercialData.clientShare)}
                        type="text"
                        handleChange={(val) => handleClientShare(val)}
                        value={
                          commercialData.clientShare > 100 ||
                          commercialData.clientShare < 0 ||
                          !Number(commercialData.clientShare).toFixed(2)
                            ? ""
                            : commercialData.clientShare
                        }
                      />
                      <ConstantInput
                        label={localization.companyShare}
                        errorMsg={localization.requiredcompanyShare}
                        required
                        isStarRequired={true}
                        type="text"
                        value={commercialData.companyShare}
                        disabled
                      />
                      <ConstantInput
                        label={localization.costPerSlot}
                        regex={Regex.twodecimal.test(
                          commercialData.costPerSlot
                        )}
                        errorMsg={
                          commercialData.costPerSlot
                            ? localization.requiredDecimal
                            : localization.requiredcostPerSlot
                        }
                        className="indianrupee"
                        type="text"
                        isPrefix
                        prefixText={"₹"}
                        required
                        isStarRequired={true}
                        handleChange={(val) =>
                          setCommercialData({
                            ...commercialData,
                            costPerSlot: val,
                          })
                        }
                      />
                    </FormSection>
                  </Fragment>
                ) : null}
              </Fragment>
            )}
            {isTarget === 2 ? (
              <Fragment>
                <FormSection title={localization.commercialDisc}>
                  <ConstantInput
                    label={localization.totalAmount}
                    errorMsg={
                      commercialData.totalAmount
                        ? localization.requiredDecimal
                        : localization.requiredtotalAmount
                    }
                    required
                    isStarRequired={true}
                    type="text"
                    className="indianrupee"
                    isPrefix
                    prefixText={"₹"}
                    regex={Regex.twodecimal.test(commercialData.totalAmount)}
                    handleChange={(val) =>
                      setCommercialData({ ...commercialData, totalAmount: val })
                    }
                  />
                  <ConstantInput
                    label={localization.costPerSlot}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                    value={commercialData.costPerSlot}
                    disabled
                  />
                </FormSection>
              </Fragment>
            ) : null}
            {isTarget === 3 ? (
              <Fragment>
                <FormSection title={localization.commercialDisc}>
                  <ConstantInput
                    label={localization.totalAmount}
                    type="text"
                    className="indianrupee"
                    isPrefix
                    prefixText={"₹"}
                    errorMsg={
                      commercialData.totalAmount
                        ? localization.requiredDecimal
                        : localization.requiredtotalAmount
                    }
                    regex={Regex.twodecimal.test(commercialData.totalAmount)}
                    required
                    isStarRequired={true}
                    handleChange={(val) =>
                      setCommercialData({ ...commercialData, totalAmount: val })
                    }
                  />
                  <ConstantInput
                    label={localization.MGSlots}
                    type="number"
                    errorMsg={localization.requiredMGSlots}
                    required
                    isStarRequired={true}
                    handleChange={(val) =>
                      setCommercialData({ ...commercialData, MGSlots: val })
                    }
                  />
                  <ConstantInput
                    label={localization.revenueSlots}
                    type="number"
                    errorMsg={localization.requiredrevenueSlots}
                    required
                    isStarRequired={true}
                    value={commercialData.revenueSlots}
                    disabled
                  />
                  <ConstantInput
                    label={localization.clientShare}
                    errorMsg={localization.requiredclientShare}
                    required
                    isStarRequired={true}
                    regex={Regex.toFixed.test(commercialData.clientShare)}
                    type="text"
                    handleChange={(val) => handleClientShare(val)}
                    value={
                      commercialData.clientShare > 100 ||
                      commercialData.clientShare < 0 ||
                      !Number(commercialData.clientShare).toFixed(2)
                        ? ""
                        : commercialData.clientShare
                    }
                  />
                  <ConstantInput
                    label={localization.companyShare}
                    errorMsg={localization.requiredcompanyShare}
                    required
                    isStarRequired={true}
                    value={commercialData.companyShare}
                    disabled
                  />
                  <ConstantInput
                    label={localization.MGPerSlot}
                    errorMsg={localization.requiredMGPerSlot}
                    required
                    isStarRequired={true}
                    value={
                      Number(commercialData.MGPerSlot) > 0
                        ? commercialData.MGPerSlot
                        : ""
                    }
                    disabled
                  />
                  <ConstantInput
                    label={localization.revenueShare}
                    errorMsg={localization.requiredrevenueShare}
                    type="number"
                    required
                    isStarRequired={true}
                    handleChange={(val) =>
                      setCommercialData({
                        ...commercialData,
                        revenueShare: val,
                      })
                    }
                  />
                </FormSection>
              </Fragment>
            ) : null}
            {isTarget === 4 || isTarget === 13 || isTarget === 14 ? (
              <Fragment>
                <FormSection title={localization.commercialDisc}>
                  <ConstantInput
                    label={localization.costPerSlot}
                    errorMsg={localization.requiredcostPerSlot}
                    required
                    isStarRequired={true}
                    regex={Regex.toFixed.test(commercialData.costPerSlot)}
                    type="number"
                    handleChange={(val) => {
                      if (
                        Number(val) === "" ||
                        Number(val) === 0 ||
                        Number(val) < Number(commercialData.takeEtaxes)
                      ) {
                        setCommercialData({
                          ...commercialData,
                          takeEtaxes: "",
                          takePerct: "",
                        });
                      } else {
                        setCommercialData({
                          ...commercialData,
                          costPerSlot: val,
                        });
                      }
                    }}
                    value={
                      commercialData.costPerSlot > 100 ||
                      commercialData.costPerSlot < 0
                        ? commercialData.costPerSlot
                        : commercialData.costPerSlot
                    }
                    min={0}
                  />
                  {errorMsg && (
                    <span style={{ color: "red", fontSize: "11px" }}>
                      {errorMsg}
                    </span>
                  )}
                  <ConstantInput
                    type="number"
                    value={
                      Number(commercialData.takeEtaxes) > 0 ||
                      Number(commercialData.takeEtaxes) <=
                        Number(commercialData.costPerSlot)
                        ? commercialData.takeEtaxes
                        : ""
                    }
                    handleChange={(val) => {
                      if (
                        Number(val) <= Number(commercialData.costPerSlot) &&
                        Number(val) >= 0
                      ) {
                        setCommercialData({
                          ...commercialData,
                          takeEtaxes: val,
                        });
                        setErrorMsg("");
                      } else {
                        setErrorMsg(
                          `${localization.takeEtaxes} must be smaller or equals to ${localization.costPerSlot} `
                        );
                      }
                      if (val === "") {
                        setErrorMsg("");
                      }
                    }}
                    label={localization.takeEtaxes}
                    // disabled={commercialData.costPerSlot ? false : true}
                    min={0}
                    max={commercialData.costPerSlot}
                    required
                    isStarRequired={true}
                    errorMsg={localization.requiredTakeEtaxes}
                  />
                  <ConstantInput
                    value={
                      Number(commercialData.takePerct) > 0
                        ? commercialData.takePerct
                        : ""
                    }
                    label={localization.takePerct}
                    disabled
                  />
                </FormSection>
              </Fragment>
            ) : null}
            {isTarget === 15 ? (
              <Fragment>
                <FormSection title={localization.commercialDisc}>
                  <ConstantInput
                    label={localization.commission}
                    required
                    type="number"
                    isStarRequired={true}
                    errorMsg={localization.requiredCommission}
                    handleChange={(val) =>
                      setCommercialData({
                        ...commercialData,
                        commission: val,
                      })
                    }
                    // max={3}
                    maxLength={3}
                    value={commercialData.commission}
                  />
                  <DropDownInput
                    data={paymentMode}
                    label={localization.paymentMode}
                    required
                    isStarRequired={true}
                    errorMsg={localization.requiredpaymentMode}
                    getIdValue={(val) =>
                      setCommercialData({
                        ...commercialData,
                        paymentMode: val.id,
                      })
                    }
                    value={commercialData.payModePrefilled.value}
                  />
                  <DropDownInput
                    data={paymentDueDays}
                    label={localization.paymentDueDays}
                    required
                    isStarRequired={true}
                    errorMsg={localization.requiredpaymentDueDays}
                    getIdValue={(val) =>
                      setCommercialData({
                        ...commercialData,
                        paymentDueDays: val.id,
                      })
                    }
                    value={commercialData.payDueDaysPrefilled.value}
                  />
                  <ConstantInput
                    label={localization.totalContract}
                    required
                    isStarRequired={true}
                    errorMsg={localization.requiredtotalContract}
                    handleChange={(val) =>
                      setCommercialData({
                        ...commercialData,
                        totalContract: val,
                      })
                    }
                    disabled={edit == 1 ? true : false}
                    value={commercialData.totalContract}
                  />
                  <ConstantInput
                    label={localization.LockIn}
                    required
                    isStarRequired={true}
                    errorMsg={localization.requiredLockIn}
                    handleChange={(val) =>
                      setCommercialData({ ...commercialData, LockIn: val })
                    }
                    value={commercialData.LockIn}
                  />
                  {isRenewal == false ? (
                    <>
                      <div className="col-md-6">
                        <DropDownInput
                          data={products}
                          label={localization.products}
                          required
                          isStarRequired={true}
                          // errorMsg={localization.requiredpaymentTerms}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              products: val.id,
                            })
                          }
                          value={commercialData.productPrefilled.value}
                        />
                      </div>
                      <div className="col-md-6">
                        <DropDownInput
                          label={localization.solutionType}
                          data={data.solutionType}
                          required
                          isStarRequired={true}
                          errorMsg={localization.solutionType}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              solution_type: val.id,
                            })
                          }
                          disabled={prefilledData?.commercial?.form_stage > 1}
                          value={commercialData?.solutionPrefilled?.value}
                        />
                      </div>
                      {
                        (!isEcom && commercialData.solution_type != 3) && 
                        <>
                          <div className="col-md-6">
                            <DropDownInput
                              data={contractCommericalTypes}
                              label={localization.commercialType}
                              required
                              isStarRequired={true}
                              errorMsg={localization.requiredcommercialType}
                              getIdValue={(val) => {
                                if(val?.id){
                                  handleIdvalueType(val);
                                }
                              }}
                              value={commercialData.commercialPrefilled.value}
                              disabled={prefilledData?.commercial?.form_stage > 1}
                            />
                          </div>
                        </>
                      }
                    </>
                  ) : null}
                </FormSection>
              </Fragment>
            ) : null}
            {/* {isSupply !== true && (
            <Fragment> */}
            {isTarget === 5 ||
            isTarget === 6 ||
            isTarget === 7 ||
            isTarget === 16 ? (
              <Fragment>
                {/* <FormSection title={localization.commercialDisc}> */}
                {/* <div className='card'> */}
                <div className="card-body">
                  <div className="col-md-6">
                    <DropDownInput
                      label={localization.solutionType}
                      data={data.solutionType}
                      required
                      isStarRequired={true}
                      errorMsg={localization.solutionType}
                      getIdValue={(val) => {
                        if (val.id == 3) {
                          setServiceCheck(true);
                          setIsTarget(7);
                          setCommercialData({
                            ...commercialData,
                            paymentTerms: paymentTermsId,
                            solution_type: val.id,
                            products: productsId,
                            commercialType: 7,
                            commercialPrefilled: {id: 7, name: 'Rental'}
                          });
                        }else if (val.id == solutionTypeId) {
                          setServiceCheck(true);
                          setCommercialData({
                            ...commercialData,
                            paymentTerms: paymentTermsId,
                            solution_type: val.id,
                            products: productsId,
                            commercialType: commercialData?.commercialType,
                            commercialPrefilled: commercialData?.commercialPrefilled
                          });
                        } else {
                          setServiceCheck(false);
                          setCommercialData({
                            ...commercialData,
                            solution_type: val.id,
                            paymentTerms: "",
                            products: "",
                            commercialType: commercialData?.commercialType,
                            commercialPrefilled: commercialData?.commercialPrefilled
                          });
                        }
                      }}
                      disabled={prefilledData?.commercial?.form_stage > 1}
                      value={commercialData.solutionPrefilled.value}
                    />
                  </div>
                  {
                    (!isEcom && commercialData.solution_type != 3) && 
                    <>
                      <div className="col-md-6">
                        <DropDownInput
                          data={contractCommericalTypes}
                          label={localization.commercialType}
                          required
                          isStarRequired={true}
                          errorMsg={localization.requiredcommercialType}
                          getIdValue={(val) => {
                            if(val?.id){
                              handleIdvalueType(val);
                            }
                          }}
                          value={commercialData.commercialPrefilled.value}
                          disabled={prefilledData?.commercial?.form_stage > 1}
                        />
                      </div>
                    </>
                  }
                  {commercialData?.commercialType == 7 && serviceCheck && (
                    <>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.managementFee}
                          type="number"
                          regex={Regex.twodecimal.test(
                            commercialData.managementFee
                          )}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              managementFee: val,
                            })
                          }
                          value={commercialData.managementFee}
                        />
                      </div>
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Pre", name: "Prepaid" },
                            { id: "Post", name: "Postpaid" },
                          ]}
                          required
                          isStarRequired={true}
                          label={"Invoice Type"}
                          errorMsg={"Invoice type is required"}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              invoice_type: val.id,
                            })
                          }
                          value={commercialData?.invoice_type}
                        />
                      </div>
                    </>
                  )}
                  {isTarget === 6 || isTarget === 7 || isTarget === 16 ? (
                    <Fragment>
                      {/* <ConstantInput
                          label={localization.installationAmount}
                          required
                          isStarRequired={true}
                          type="text"
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          errorMsg={
                            commercialData.installationAmount
                              ? localization.requiredDecimal
                              : localization.requiredinstallationAmount
                          }
                          regex={Regex.twodecimal.test(
                            commercialData.installationAmount
                          )}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              installationAmount: val,
                            })
                          }
                        /> */}
                      {!isEcom &&
                      <div className="col-md-6">
                        <DropDownInput
                          data={paymentTerms}
                          label={localization.paymentTerms}
                          required
                          isStarRequired={true}
                          errorMsg={localization.requiredpaymentTerms}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTerms: val.id,
                            })
                          }
                          disabled={
                            commercialData.solution_type == solutionTypeId &&
                            isTarget === 7
                              ? true
                              : false
                          }
                          value={
                            commercialData.solution_type == solutionTypeId &&
                            isTarget === 7
                              ? monthly
                              : commercialData.paymentTermPrefilled.value
                          }
                        />
                      </div>
                      }
                      {/* <div className='col-md-6'>  
                      <DropDownInput
                         data={[
                          { id: '0', name: '0%' },
                          { id: '9', name: '9%' },
                          { id: '12', name: '12%' },
                          { id: '15', name: '15%' },
                          { id: '18', name: '18%' },
                        ]}
                          label={localization.latePayCharge}
                          isStarRequired={true}
                          required
                          errorMsg={localization.latePayCharge}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              latePayCharge: val.id,
                            })
                          }
                          value={commercialData.latePaymentPrefilled.value}
                        />
                         </div> */}
                      {/* <div className='col-md-6'>
                         <ConstantInput
                          label={localization.paymentTermsDesc}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTermsDesc: val,
                            })
                          }
                          value={commercialData.paymentTermsDesc}
                        />
                         </div> */}
                      { !isEcom && 
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.subAmt}
                          required
                          isStarRequired={true}
                          placeholder={`Enter Quarterly or Monthly Amount Without GST`}
                          type="number"
                          className="indianrupee"
                          isPrefix
                          prefixText={"₹"}
                          errorMsg={
                            commercialData.subAmt
                              ? localization.requiredDecimal
                              : localization.requiredsubAmt
                          }
                          regex={Regex.twodecimal.test(commercialData.subAmt)}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              subAmt: val,
                            })
                          }
                          value={commercialData.subAmt}
                        />
                        </div>
                        }
                      </Fragment>
                    ) : null}
                    {isTarget === 5 ? (
                      <Fragment>
                      <div className='col-md-6'>
                        {leadType === 1 ?
                         <>
                          <ConstantInput
                          label={localization.totalAmount}
                          type="number"
                          className="indianrupee"
                          isPrefix
                          prefixText={"₹"}
                          regex={Regex.twodecimal.test(
                            commercialData.totalAmount
                          )}
                          errorMsg={
                            commercialData.subAmt
                              ? localization.requiredDecimal
                              : localization.requiredtotalAmount
                          }
                          required
                          isStarRequired={true}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              totalAmount: val,
                            })
                          }
                          value={commercialData.totalAmount}
                          //disabled={true}
                        />
                         </>
                        : <ConstantInput
                              label={localization.totalAmount}
                              type="number"
                              className="indianrupee"
                              isPrefix
                              prefixText={'₹'}
                              regex={Regex.twodecimal.test(
                                commercialData.totalAmount
                              )}
                              errorMsg={
                                commercialData.subAmt
                                  ? localization.requiredDecimal
                                  : localization.requiredtotalAmount
                              }
                              required
                              isStarRequired={true}
                              handleChange={(val) =>
                                setCommercialData({
                                  ...commercialData,
                                  totalAmount: val,
                                })
                              }
                              value={commercialData.totalAmount}
                          />
                      }
                        
                        </div>
                        <div className='col-md-6'>
                        <ConstantInput
                          label={localization.paymentTermsDesc}
                          handleChange={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTermsDesc: val,
                            })
                          }
                          value={commercialData.paymentTermsDesc}
                        />
                      </div>
                      {/* <DropDownInput
                          data={paymentTerms}
                          label={localization.paymentTerms}
                          required
                          errorMsg={localization.requiredpaymentTerms}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              paymentTerms: val.id,
                            })
                          }
                        /> */}
                    </Fragment>
                  ) : null}
                  {!isEcom ? (
                  <div className="col-md-6">
                    <DropDownInput
                      data={paymentMode}
                      label={localization.paymentMode}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredpaymentMode}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          paymentMode: val.id,
                        })
                      }
                      value={commercialData.payModePrefilled.value}
                    />
                  </div>
                  ): null}
                  {!isEcom ? (
                  <div className="col-md-6">
                    <DropDownInput
                      data={paymentDueDays}
                      label={localization.paymentDueDays}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredpaymentDueDays}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          paymentDueDays: val.id,
                        })
                      }
                      value={commercialData.payDueDaysPrefilled.value}
                    />
                  </div>
                  ): null}
                  {/* <DropDownInput
                      data={totalContractList}
                      label={localization.totalContract}
                      required
                      errorMsg={localization.requiredtotalContract}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          totalContract: val.id,
                        })
                      }
                    /> */}
                  <div className="col-md-6">
                    <ConstantInput
                      label={localization.totalContract}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredtotalContract}
                      handleChange={(val) => {
                        setCommercialData({
                          ...commercialData,
                          totalContract: val,
                        });
                        setAgreementLength(val);
                      }}
                      disabled={edit == 1 ? true : false}
                      value={commercialData.totalContract}
                      type="number"
                    />
                  </div>
                  {/* <DropDownInput
                      data={totalContractList}
                      label={localization.LockIn}
                      required
                      errorMsg={localization.requiredLockIn}
                      getIdValue={(val) =>
                        setCommercialData({ ...commercialData, LockIn: val.id })
                      }
                    /> */}
                  <div className="col-md-6">
                    <ConstantInput
                      label={localization.LockIn}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredLockIn}
                      handleChange={(val) =>
                        setCommercialData({ ...commercialData, LockIn: val })
                      }
                      value={commercialData.LockIn}
                      type="number"
                    />
                  </div>
                  {/* {console.log(commercialData)} */}
                  {!isEcom ? (
                  <div className="col-md-6">
                    <DropDownInput
                      data={[
                        { name: "Direct Sales", id: "Direct Sales" },
                        {
                          name: "PO to Vendor By Park+",
                          id: "PO to Vendor By Park+",
                        },
                        {
                          name: "PO by Vendor To Park+ ",
                          id: "PO by Vendor To Park+",
                        },
                        { name: "Channel Partner", id: "Channel Partner" },
                        {
                          name: "Dealer with Service",
                          id: "Dealer with Service",
                        },
                        {
                          name: "Dealer without Service",
                          id: "Dealer without Service",
                        },
                      ]}
                      label={localization.typeOfSales}
                      required={isSupply ? false : true}
                      isStarRequired={isSupply ? false : true}
                      errorMsg={isSupply ? "" : localization.isRequired}
                      getIdValue={(val) => handleSalesType(val)}
                      value={commercialData?.salesType}
                    />
                  </div>
                  ): null}
                  {(saleType === "PO to Vendor By Park+" ||
                    saleType === "PO by Vendor To Park+" ||
                    saleType === "Channel Partner" ||
                    saleType === "Dealer with Service" ||
                    saleType === "Dealer without Service") && (
                    <>
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { name: "Golf automation", id: "Golf automation" },
                            { name: "Yash automation", id: "Yash automation" },
                            { name: "Dtrendz", id: "Dtrendz" },
                            { name: "Swaraj", id: "Swaraj" },
                            { name: "Raj Udyog", id: "Raj Udyog" },
                            { name: "Accurate", id: "Accurate" },
                            { name: "Others", id: "Others" },
                          ]}
                          label={localization.channelPartner}
                          required={isSupply ? false : true}
                          isStarRequired={isSupply ? false : true}
                          errorMsg={isSupply ? "" : localization.isRequired}
                          getIdValue={(val) => {
                            setCommercialData({
                              ...commercialData,
                              channelPartner: val.id,
                              channelPartnerValue: "",
                            });
                            //handleRemoverValue('channelParter',val.id);
                          }}
                          value={commercialData?.channelPartner}
                        />
                      </div>
                      {commercialData.channelPartner === "Others" && (
                        <div className="col-md-6">
                          <ConstantInput
                            handleChange={(val) =>
                              setCommercialData({
                                ...commercialData,
                                channelPartnerValue: val,
                              })
                            }
                            type="text"
                            label={localization.channelPartnerName}
                            value={commercialData?.channelPartnerValue}
                            isStarRequired={true}
                            required
                          />
                        </div>
                      )}
                    </>
                  )}

                  {/* <ConstantInput
                      label={localization.yearlyInclin}
                      required
                      isStarRequired={true}
                      type="number"
                      errorMsg={localization.requiredyearlyInclin}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          yearlyInclin: val,
                        })
                      }
                    /> */}
                  {/* <ConstantInput
                      label={localization.securityDeposit}
                      // required
                      // isStarRequired={true}
                      className="indianrupee"
                      isPrefix
                      prefixText={'₹'}
                      // regex={Regex.twodecimal.test(
                      //   commercialData.securityDeposit
                      // )}
                      // errorMsg={
                      //   commercialData.securityDeposit
                      //     ? localization.requiredDecimal
                      //     : localization.requiredsecurityDeposit
                      // }
                      type="number"
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          securityDeposit: val,
                        })
                      }
                      value={commercialData.securityDeposit}
                    /> */}
                  {/* <ConstantInput
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          slotsNoFourWheeler: val,
                        })
                      }
                      type="number"
                      value={commercialData.slotsNoFourWheeler}
                       regex={Regex.number.test(
                        commercialData.slotsNoFourWheeler
                      )}
                      errorMsg={localization.requiredslotsNoFourWheeler} 
                      label={localization.slotsNoFourWheeler}
                    /> */}
                  {/* <ConstantInput
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          slotsNoTwoWheeler: val,
                        })
                      }
                      label={localization.slotsNoTwoWheeler}
                      type="number"
                      value={commercialData.slotsNoTwoWheeler}
                      
                    /> */}
                  {/* <ConstantInput
                      value={commercialData.TagsNoPost}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          TagsNoPost: val,
                        })
                      }
                      required
                      isStarRequired={true}
                      type="number"
                      errorMsg={localization.requiredTagsNoPost}
                      label={localization.TagsNoPost}
                    /> */}

                  {isRenewal == false ? (
                    <>
                      {/* <div className='col-md-6'>
                      <DatePicker
                        label={localization.expectedLive}
                        required={true}
                        handleChange={(val) =>
                          setCommercialData({ ...commercialData, expectedLive: val })
                        }
                        minimumDate={new Date()}
                        value={commercialData.expectedLive}
                      />
                      </div> */}
                      {((!isEcom) && (!serviceCheck || isTarget !== 7)) && (
                        <div className="col-md-6">
                          <DropDownInput
                            data={products}
                            label={localization.products}
                            required
                            isStarRequired={true}
                            // errorMsg={localization.requiredpaymentTerms}
                            getIdValue={(val) =>
                              setCommercialData({
                                ...commercialData,
                                products: val.id,
                              })
                            }
                            // disabled={commercialData.solution_type == solutionTypeId && isTarget === 7? true: false}
                            value={commercialData.productPrefilled.value}
                          />
                        </div>
                      )}
                      <div className="col-md-6">
                        <DatePicker
                          handleChange={(val) => {
                            setCommercialData({
                              ...commercialData,
                              agreementSigningDate: val,
                            });
                            openAgreementBlock(val);
                          }}
                          label={localization.agreementSigningDate}
                          // maxDate={new Date()}
                          value={moment(
                            commercialData.agreementSigningDate,
                            "DD-MM-YYYY"
                          ).format("DD-MM-YYYY")}
                        />
                      </div>
                      <div className="col-md-6">
                        <DatePicker
                          handleChange={(val) => {
                            setCommercialData({
                              ...commercialData,
                              agreementContractPeriodFrom: val,
                            });
                            setAgreementEndLength(val);
                          }}
                          label={
                            minDateIndex !== null
                              ? localization.agreementContractPeriodFrom
                              : `Previous Date must be selected.`
                          }
                          value={moment(
                            commercialData?.agreementContractPeriodFrom,
                            "DD-MM-YYYY"
                          ).format("DD-MM-YYYY")}
                        />
                      </div>
                      <div className="col-md-6">
                        <DatePicker
                          handleChange={(val) => {
                            setCommercialData({
                              ...commercialData,
                              agreementContractPeriodTo: val,
                            });
                          }}
                          label={localization.agreementContractPeriodTo}
                          value={agreementEndDate}
                          // commercialData?.agreementEndDate||
                          // minimumDate={new Date()}
                          disabled={true}
                        />
                      </div>
                      {!isEcom &&
                      <>
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { name: "Yes", id: "Yes" },
                            { name: "No", id: "No" },
                          ]}
                          label={`Is PO Available?`}
                          required={true}
                          isStarRequired={isSupply ? false : true}
                          errorMsg={localization.isRequired}
                          getIdValue={(val) =>
                            setCommercialData({
                              ...commercialData,
                              isPOAvailable: val.id,
                            })
                          }
                          value={commercialData.isPOAvailable}
                        />
                      </div>
                      {commercialData?.isPOAvailable === "Yes" && (
                        <>
                          {/* <div className='col-md-6'>
                            <DropDownInput
                                data={[
                                  { name: 'Agreement/Contract', id: 1 },
                                  { name: 'PO', id: 2 },
                                  { name: 'Both', id: 3 },
                                ]}
                                label={localization.contractType}
                                required={isSupply ? false : true}
                                isStarRequired={isSupply ? false : true}
                                errorMsg={isSupply ? '' : localization.isRequired}
                                getIdValue={(val) => setCommercialData({
                                  ...commercialData,
                                  detailsProvide: val.id,
                                  detailsProvideName: val.name
                                })}
                                value={commercialData?.detailsProvideName}
                            />
                          </div> */}
                          <div className="col-md-6">
                            <DatePicker
                              handleChange={(val) =>
                                setCommercialData({
                                  ...commercialData,
                                  pODate: val,
                                })
                              }
                              label={
                                isApartment === 1
                                  ? `Closure Date`
                                  : localization.pODate
                              }
                              required={false}
                              maxDate={new Date()}
                              value={commercialData?.pODate}
                            />
                          </div>
                          <div className="col-md-6">
                            <ConstantInput
                              handleChange={(val) =>
                                setCommercialData({
                                  ...commercialData,
                                  pONumber: val,
                                })
                              } 
                              type="text"
                              regex={Regex.number.test(commercialData.pONumber)}
                              label={localization.pONumber}
                              value={commercialData.pONumber}
                              isStarRequired={true}
                              required
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="w-100">
                              <FileUpload
                                id="pOUpload"
                                accept=".pdf,.png,.jpg"
                                documentUploadUrl={documentUploadUrl}
                                reset={false}
                                onChange={(val) => {
                                  setCommercialData({
                                    ...commercialData,
                                    pOUpload: val,
                                  });
                                }}
                                prefilledFilename={
                                  commercialData?.pOUpload?.length > 0
                                    ? commercialData?.pOUpload?.length +
                                      " files attached"
                                    : ""
                                }
                                fileUrl={
                                  Array.isArray(commercialData?.pOUpload)
                                    ? commercialData.pOUpload[0]
                                    : commercialData?.pOUpload || null
                                }
                                required
                                multiple={true}
                                // value={agreementData.pOUpload}
                              >
                                <span className="btn btn-transparent">
                                  {localization.pOUpload}
                                  <span
                                    className="label-star"
                                    style={{ color: "red" }}
                                  >
                                    &nbsp; *
                                  </span>
                                </span>
                              </FileUpload>
                              &nbsp;
                              <label
                                className={`error ${
                                  commercialData?.pOUpload === null
                                    ? "error-block"
                                    : ""
                                }`}
                              >
                                {localization.pleaseUploadPO}
                              </label>
                            </div>
                          </div>
                        </>
                      )}
                      </>
                    }

                      <div className="col-md-6">
                        <FileUpload
                          id="agreementContractUpload"
                          accept=".pdf,.png,.jpg"
                          documentUploadUrl={documentUploadUrl}
                          reset={false}
                          onChange={(val) => {
                            setCommercialData({
                              ...commercialData,
                              contract_doc: val,
                            });
                          }}
                          prefilledFilename={commercialData?.contract_doc}
                          fileUrl={commercialData?.contract_doc || null}
                        >
                          <span className="btn btn-transparent">
                            {localization.agreementContractUpload}
                            <span
                              className="label-star"
                              style={{ color: "red" }}
                            >
                              &nbsp; *
                            </span>
                          </span>
                        </FileUpload>
                      </div>
                      {!isEcom && leadType == 2 ? (
                        <div className="col-md-6">
                          <DropDownInput
                            data={[
                              { name: "Builder", id: "Builder" },
                              { name: "RWA", id: "RWA" },
                            ]}
                            required
                            isStarRequired={true}
                            label={localization.builderRwa}
                            getIdValue={(val) =>
                              setCommercialData({
                                ...commercialData,
                                builderType: val.id,
                              })
                            }
                            value={commercialData.builderType ?? ""}
                            errorMsg={localization.builderRwaError}
                          />
                        </div>
                      ) : null}
                      {/* <div className='col-md-6'>
                      <FileUpload
                        id="revDoc"
                        accept=".pdf,.png,.jpg"
                        documentUploadUrl={documentUploadUrl}
                        onChange={(val) => setCommercialData({
                          ...commercialData,
                          rel_docs: val.toString(),
                        })}
                        // prefilledFilename={agreementData?.pOUpload}
                        multiple={true}
                      >
                      <span className="btn btn-transparent">
                        {localization.uploadRevDoc}
                      </span>
                        </FileUpload>
                        </div>   */}
                    </>
                  ) : null}
                  {/* {is_fastag ?
                      <DropDownInput
                      data={[
                          { id: 'yes', name: 'Yes' },
                          { id: 'No', name: 'No' },
                        ]}
                        required
                        isStarRequired={true}
                        label={localization.fastag_integrable}
                        errorMsg={localization.fastag_integrable}
                        getIdValue={(val) =>
                          setCommercialData({
                            ...commercialData,
                            fastag_integrable: val.id,
                          })
                        }
                        value={commercialData.fastag_integrable ?commercialData.fastag_integrable:'No' }
                      />
                      :null}   */}

                  {/* {isSupply === false && ( */}

                  {/* )} */}
                  {lead_category?.id === 2 ? (
                    <DropDownInput
                      data={splNameData}
                      label={localization.supplyNamePost}
                      required
                      errorMsg={localization.requiredsupplyNamePost}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          supplyName: val.id,
                        })
                      }
                    />
                  ) : null}
                  {isTarget === 15 ? (
                    <ConstantInput
                      label={localization.totalContract}
                      required
                      isStarRequired={true}
                      errorMsg={localization.requiredtotalContract}
                      handleChange={(val) =>
                        setCommercialData({
                          ...commercialData,
                          totalContract: val,
                        })
                      }
                      disabled={edit == 1 ? true : false}
                      value={commercialData.totalContract}
                    />
                  ) : null}
                  {/* <div className="col-md-6">
                    <DropDownInput
                      data={getUserBasedDropdown?.dropdown_data}
                      label={"Select User"}
                      required
                      errorMsg={localization.isRequired}
                      // getValueById={getUserBasedDropdown?.external_user}
                      value={commercialData?.externalUserPrefilled?.value}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          external_user_name: val.id,
                        })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={handleCreateUserModal}
                    >
                      <i className="fa fa-user" aria-hidden="true"></i>
                      <span style={{ marginRight: "20px" }}>Create user</span>
                    </button>
                  </div> */}

                  <hr />
                  {cp_permission == 1 ? (
                    <DropDownInput
                      data={channelPartnerData}
                      label={localization.channelPartner}
                      getIdValue={(val) =>
                        setCommercialData({
                          ...commercialData,
                          channelPartnerWarehouse: val.id,
                        })
                      }
                    />
                  ) : null}
                  {/* {console.log(channelPartner)} */}
                </div>
              </Fragment>
            ) : null}
            {/* </Fragment>
          )} */}
          </Fragment>
        ) : null}
      </div>
      <div className="mt-2"></div>
      <div className="col-md-12 text-right">
        <button
          onClick={() => handleCommercialSubmit()}
          className="btn btn-theme mb-2 btn-sm"
          disabled={disabled}
        >
          Save & Next
        </button>
      </div>
      <div className="mb-4"></div>
      <ModalPop
        title={"Create User"}
        show={createUserModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <ConstantInput
                label={"First Name"}
                errorMsg={localization.isRequired}
                type="text"
                required
                isStarRequired={true}
                value={inputData?.first_name}
                handleChange={(val) => {
                  handleInputValue("first_name", val);
                }}
                maxLength={100}
              />
            </div>
            <div className="col-md-6">
              <ConstantInput
                label={"Last Name"}
                errorMsg={localization.isRequired}
                type="text"
                required
                isStarRequired={true}
                value={inputData?.last_name}
                handleChange={(val) => {
                  handleInputValue("last_name", val);
                }}
                maxLength={100}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <ConstantInput
                label={"Email Id"}
                errorMsg={localization.isRequired}
                type="email"
                required
                isStarRequired={true}
                value={inputData?.email_id}
                handleChange={(val) => {
                  handleInputValue("email_id", val);
                }}
                maxLength={100}
              />
            </div>
            <div className="col-md-6">
              <ConstantInput
                label={"Mobile Number"}
                errorMsg={localization.isRequired}
                type="number"
                required
                isStarRequired={true}
                value={inputData?.mobile_number}
                handleChange={(val) => {
                  handleInputValue("mobile_number", val);
                }}
                maxLength={10}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <DropDownInput
                data={data?.external_roles}
                label={"Role"}
                required
                // value={inputData?.external_role}
                errorMsg={localization.isRequired}
                getIdValue={(val) => {
                  handleInputValue("external_role", val?.id);
                }}
                isStarRequired={true}
              />
            </div>
          </div>
          <div className="mb-5 mt-5 d-flex" style={{justifyContent: 'flex-end'}}>
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              onClick={handleCreateUser}
            >
              {"Create"}
            </button>
          </div>
        </div>
      </ModalPop>
    </Fragment>
  );
};

CommercialNew.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
  handleCommercialSubmit: PropTypes.func,
  isApartment: PropTypes.bool,
};

export default CommercialNew;
